import { createTicketsSlaInsightsApi } from './insights';
export * from './insights';
var relativePath = '/sla';
export var createSlaApi = function (baseUrl, http) {
    var apiUrl = baseUrl + relativePath;
    return {
        getAll: function () {
            return http.get(apiUrl);
        },
        get: function (slaPolicyDto) {
            return http.get("".concat(apiUrl, "/").concat(slaPolicyDto.id));
        },
        add: function (addV2SlaPolicyDto) {
            return http.post("".concat(apiUrl), addV2SlaPolicyDto);
        },
        enable: function (enableSlaPolicyDto) {
            return http.put("".concat(apiUrl, "/").concat(enableSlaPolicyDto.id, "/enable"), enableSlaPolicyDto);
        },
        update: function (updateV2SlaPolicyDto) {
            return http.put("".concat(apiUrl, "/").concat(updateV2SlaPolicyDto.id), updateV2SlaPolicyDto);
        },
        delete: function (deleteSlaPolicyDto) {
            return http.delete("".concat(apiUrl, "/").concat(deleteSlaPolicyDto.id));
        },
        reorder: function (reorderSlaPolicyDto) {
            return http.post("".concat(apiUrl, "/reorder"), reorderSlaPolicyDto);
        },
        insights: createTicketsSlaInsightsApi(baseUrl, http)
    };
};
//# sourceMappingURL=index.js.map